export const REQUESTS = {
  baseURL: process.env.REACT_APP_BUYERS_BE,
  request: {
    fetchAuctionsWatch: '/auctions',
    setAuctionWatch: '/watchAuction',
  },
};
